<script setup lang="ts">
import Button from '@/Components/Ui/Button.vue';
import { stop } from '@/routes/impersonation';
import { useForm, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
const page = usePage();
// Les props sont indéfinies tant que la page n'est pas reçue par <App>.
const impersonation = computed(() => page.props?.auth?.impersonation ?? null);
const form = useForm({});
</script>

<template>
    <div
        v-if="impersonation"
        role="status"
        class="bg-alert-soft text-ink sticky top-0 z-[100] flex flex-wrap items-center justify-between gap-3 border-b px-4 py-3 text-sm"
    >
        <span>{{
            $t('impersonation.banner', {
                name: impersonation.name,
                email: impersonation.email,
            })
        }}</span>
        <Button
            size="sm"
            :loading="form.processing"
            :disabled="form.processing"
            @click="form.post(stop().url)"
        >
            {{ $t('impersonation.stop') }}
        </Button>
    </div>
</template>
